
require('./brokerInformativePopUp.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');
const { FormattedText } = require('core/i18n').i18n;

// @Components
const OKModal = require('components/commons/OKModal/OKModal');

class BrokerInformativePopUp extends React.Component {
    buildContent() {
        const { contentKey } = this.props;
        return (
            <div className="broker-informative-pop-up__content">
                <FormattedText value={contentKey}/>
            </div>
        );
    }

    render() {
        const {
            handleClose,
            isOpen,
            featureFlag,
            titleKey,
            buttonKey,
        } = this.props;
        if (!featureFlag) {
            return null;
        }
        return (
            <div>
                <OKModal
                    isOpen={isOpen}
                    title={titleKey}
                    titleAlignment="center"
                    content={this.buildContent()}
                    descriptionAlignment="center"
                    footerType="action"
                    primaryButtonText={buttonKey}
                    onCloseCallback={!!handleClose && handleClose}
                    onPrimaryButtonClick={!!handleClose && handleClose}
                />
            </div>
        );
    }
}

BrokerInformativePopUp.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    featureFlag: PropTypes.bool.isRequired,
    titleKey: PropTypes.string.isRequired,
    contentKey: PropTypes.string.isRequired,
    buttonKey: PropTypes.string.isRequired,
};

module.exports = BrokerInformativePopUp;


